export const APP_BASE_URL = '';

export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SUCCESS: 'success',
  PROGRESS: 'progress',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
  TRANSFER_TO_QUEUE: 4
};

export const WOOT_PREFIX = 'chatwoot-widget:';

export const PRECHAT_FIELD_NAMES = {
  CONTACT_REASON : "contactReason"
}

export const FILE_TRANSFER = {
  ALLOW_ALL:"0",
  WORKER_ONLY:"1",
  CUSTOMER_ONLY:"2"
}

export const TRANSCRIPT_DOWNLOAD = {
  NOT_ALLOWED:"0",
  ALLOWED:"1"
}

export const ANONYMOUS_CUSTOMER = 'Anonymous Customer';

export const OFFLINE_MESSAGE = "Your chat is offline, please check your internet connection"
